module.exports = __webpack_public_path__ + "img/case-logo-01.24a3cdf9.png";